import { Link, NavLink } from "react-router";
import { Dialog, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { cn } from "@/utils/cn";
import { Button } from "@/components/ui/button";

export const ContentNav = ({
    open,
    onClose,
    navigationMap,
    user,
    interestForm,
}) => {
    return (
        <Dialog open={open} onClose={onClose} className="lg:hidden">
            <div className="fixed inset-0 z-50">
                <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-linear-to-t/oklch from-beige from-30% via-[oklch(0.9894_0.0119_101.48)] via-70% to-white p-4 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                    <div className="flex items-center">
                        <div className="flex">
                            <Link
                                to="/"
                                className="-m-1.5 p-1.5"
                                onClick={() => onClose(false)}
                            >
                                <span className="sr-only">WELNIDO</span>
                                <img
                                    alt="WELNIDO Logo"
                                    src="/logo-darkgreen.svg"
                                    height="80"
                                    width="140"
                                />
                            </Link>
                        </div>
                        <div className="ms-auto flex">
                            <button
                                type="button"
                                onClick={() => onClose(false)}
                                className="-me-2.5 rounded-md p-2.5 text-gray-700"
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon
                                    aria-hidden="true"
                                    className="size-6"
                                />
                            </button>
                        </div>
                    </div>
                    <div className="mt-6 flow-root">
                        <div className="-my-6">
                            <nav className="space-y-2 py-6">
                                {navigationMap.map((item) => (
                                    <NavLink
                                        key={item.name}
                                        to={item.to}
                                        end={item.end}
                                        onClick={() => onClose(false)}
                                        className={({ isActive }) =>
                                            cn(
                                                "text-darkgreen -mx-3 block rounded-lg px-3 pt-2 text-lg/7 font-semibold *:border-b-2 *:border-transparent hover:bg-gray-50",
                                                isActive &&
                                                    "*:border-emerald-950",
                                            )
                                        }
                                    >
                                        <span className="-mx-1 p-2 pt-0">
                                            {item.name}
                                        </span>
                                    </NavLink>
                                ))}
                            </nav>
                            {!interestForm && (
                                <div className="mt-auto px-1">
                                    {user ? (
                                        <>
                                            <Button
                                                variant="success"
                                                size="default"
                                                asChild
                                            >
                                                <Link to="/login">
                                                    View account
                                                </Link>
                                            </Button>
                                        </>
                                    ) : (
                                        <div className="grid gap-3">
                                            <Button
                                                variant="primary"
                                                size="default"
                                                asChild
                                            >
                                                <Link to="/login">Log in</Link>
                                            </Button>
                                            <Button
                                                variant="success"
                                                size="default"
                                                asChild
                                            >
                                                <Link to="/register">
                                                    List your practice
                                                </Link>
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </DialogPanel>
            </div>
        </Dialog>
    );
};
